// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".AttachmentThumbnail-cls1__f98904ff59de2497524c{/*!*/}.AttachmentThumbnail-cls2__ebff59ea2ab0ed70e86c{position:absolute;top:31px;left:-6px;z-index:100;width:0;height:0;border-style:solid none solid solid;border-width:7px 0px 7px 7px;border-color:transparent transparent transparent var(--brand-colors-error-900);transform:rotate(-45deg)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "AttachmentThumbnail-cls1__f98904ff59de2497524c",
	"cls2": "AttachmentThumbnail-cls2__ebff59ea2ab0ed70e86c AttachmentThumbnail-cls1__f98904ff59de2497524c"
};
export default ___CSS_LOADER_EXPORT___;
